import { render } from "./BilanComponent.vue?vue&type=template&id=33994800"
import script from "./BilanComponent.vue?vue&type=script&lang=js"
export * from "./BilanComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__